var __TEMP__ = require('./_coreJsData.js');var coreJsData = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isFunction.js');var isFunction = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./stubFalse.js');var stubFalse = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = coreJsData ? isFunction : stubFalse;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isMaskable;
